define('core/mixins/withEmailVerifyLink',[
    'jquery',
    'underscore',

    'core/config',
    'core/utils',
], function (
    $,
    _,

    config,
    coreUtils
) {
    'use strict';

    var handler = coreUtils.preventDefaultHandler;

    var EmailVerifyLinkMixin = {
        events: {
            'click [data-action=verify-email]': 'showVerifyEmailPopup',
        },

        showVerifyEmailPopup: handler(function (evt) {
            var forumId = $(evt.target).attr('data-forum');
            var url = config.urls.verifyEmail;

            if (forumId)
                url = url + '?f=' + forumId;

            return coreUtils.openWindow(url, '_blank', {
                width: 460,
                height: 355,
            });
        }),
    };

    return function withEmailVerifyLink() {
        this.events = _.defaults({}, this.events, EmailVerifyLinkMixin.events);

        _.extend(this, _.pick(EmailVerifyLinkMixin, 'showVerifyEmailPopup'));

    };
});

